export default __webpack_public_path__ + "static/media/github.0046aca0.svg";